import useStore, { updateScreenWidth } from '../Store/Store';

import ArrowIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, IconButton, Link, Typography } from '@mui/material';
import React from 'react';
import Logo from '../images/logo.png';
import SideImage from '../images/loginImage.svg';
import { loginApi } from '../utils/api';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { auth, provider, signInWithPopup } from '../utils/firebase';
import { capitalize, isEmpty } from 'lodash';
import { careUserType } from '../constants';
import UserType from './SignupOnboardingSteps/UserType';
import UserForm from './SignupOnboardingSteps/UserForm';
import InviteCareTeam from './SignupOnboardingSteps/InviteCareTeam';
import InviteCareRecipients from './SignupOnboardingSteps/InviteCareRecipients';

const SignUpOnboarding = () => {
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);

  const [state, setState] = React.useState({
    step: 1,
    userType: '',
    errorMessage: '',
  });

  const updateDimensions = () => {
    updateScreenWidth(window.innerWidth);
  };
  React.useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  React.useEffect(() => {
    if (!isEmpty(user)) {
      history('/main');
    }
  }, [user]);

  const handleNextStep = () => {
    if (isEmpty(state.userType)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Must select one user type!' };
      });
    }
    setState((prev) => {
      return { ...prev, step: prev.step + 1, errorMessage: '' };
    });
  };

  const handleBackStep = () => {
    setState((prev) => {
      return { ...prev, step: prev.step - 1, errorMessage: '' };
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'white',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: width > 1050 ? '50%' : '100%',
          padding: '1rem',
        }}
      >
        <Box
          component="img"
          sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
          alt="Mask group"
          src={Logo}
        />

        {state.step === 1 && (
          <UserType
            userType={state.userType}
            setUserType={(type) =>
              setState((prev) => {
                return { ...prev, userType: type };
              })
            }
            handleNextStep={handleNextStep}
          />
        )}

        {state.step === 2 && <UserForm handleBackStep={handleBackStep} handleNextStep={handleNextStep} />}
        {state.step === 3 && <InviteCareTeam handleBackStep={handleBackStep} handleNextStep={handleNextStep} />}
        {state.step === 4 && <InviteCareRecipients handleBackStep={handleBackStep} handleNextStep={handleNextStep} />}

        <Typography component="h1" variant="subtitle1" style={{ color: 'red' }} textAlign="center" my={1}>
          {state.errorMessage}
        </Typography>
      </Box>
      {width > 1050 && (
        <Box
          component="img"
          sx={{
            width: '50%',
            height: '97%',
            objectFit: 'cover',
            padding: '1rem',
            borderRadius: '30px',
          }}
          alt="Rectangle"
          src={SideImage}
        />
      )}
    </Box>
  );
};

export default SignUpOnboarding;
